/**
 * Customer Portal (UI) - reseller dashboard variant.
 */
import type { DashboardResponse } from '../../types/portal';
import { MetricCardsGrid } from './MetricCardsGrid';

type ResellerDashboardProps = {
  dashboard: DashboardResponse;
};

export function ResellerDashboard({ dashboard }: ResellerDashboardProps) {
  return (
    <div className="row row-cards">
      <div className="col-12">
        <MetricCardsGrid
          title="Reseller Control View"
          description="Reseller-level performance metrics across managed account traffic."
          metrics={dashboard.metrics}
        />
      </div>
    </div>
  );
}
